import { CartBuyerIdentityInput, ShopifyCustomer } from 'api/shopifyV2/types';

export function formatCartBuyerIdentityInput(
  customer: ShopifyCustomer,
  cartId: string,
  countryCode: string,
  accessToken?: string
): CartBuyerIdentityInput {
  if (!customer || !accessToken) {
    return { cartId, buyerIdentity: {} };
  }

  const buyerIdentity: CartBuyerIdentityInput['buyerIdentity'] = {
    email: customer.email,
    phone: customer.phone || undefined,
    customerAccessToken: accessToken
  };

  if (customer.defaultAddress) {
    buyerIdentity.deliveryAddressPreferences = [
      {
        customerAddressId: customer.defaultAddress.id
      }
    ];
  }

  // countryCode is used to determine currency/prices for the user's cart
  // should be restricted to a country with the desired currency for the respective store
  buyerIdentity.countryCode = countryCode;

  return {
    cartId,
    buyerIdentity
  };
}
